var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNonProp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.433594 8.35745C0.433594 3.75363 4.16573 0.0214844 8.76955 0.0214844H32.0597C36.6635 0.0214844 40.3957 3.75362 40.3957 8.35744V31.6476C40.3957 36.2514 36.6635 39.9836 32.0597 39.9836H8.76956C4.16574 39.9836 0.433594 36.2514 0.433594 31.6476V8.35745Z",
    fill: "#155DFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4141_6452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4111 28.332C25.0112 28.332 28.7402 24.603 28.7402 20.0029C28.7402 15.4029 25.0112 11.6738 20.4111 11.6738C15.8111 11.6738 12.082 15.4029 12.082 20.0029C12.082 24.603 15.8111 28.332 20.4111 28.332Z",
    stroke: "white",
    strokeWidth: 1.66582,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9141 20.0037L19.5799 21.6695L22.9115 18.3379",
    stroke: "white",
    strokeWidth: 1.66582,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4141_6452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9898,
    height: 19.9898,
    fill: "white",
    transform: "translate(10.418 10.0078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonProp);
export default __webpack_public_path__ + "static/media/Non-prop.face2bb9424e8ad7cbffb8e9fa6a370c.svg";
export { ForwardRef as ReactComponent };